import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Affiliation() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Academics"
          title2=""
          parentTitle="About"
          path="School Rules"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Affiliation & course study</h2>

            <div className="about-content-card">
              {/* BULLET SECTION */}
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students are expected to be present in the class room before
                    8.10 am. Habitual late coming is unacceptable. The school
                    gate closes at 8.10 am. Late comers are not normally allowed
                    to enter the campus.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>Students must speak English in the school campus.</span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    All students must be clean, neatly dressed and come in the
                    school uniform according to the season.
                  </span>
                </div>
                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students must be regular in attendance, punctual and
                    diligent in their studies and assignments.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Care should be taken for all school property. Students
                    should not scratch or damage any school furniture, write or
                    draw anything on the walls, or cause any damage to things
                    belonging to others. Any damage done should be reported at
                    once to the class teacher or the principal. Students are
                    expected to make good the damage done.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    No books other than textbooks, library books, periodicals,
                    magazines, or papers may be brought to school without the
                    principal's permission.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students are not permitted to bring any portable electronic
                    instruments such as mobile phones, music players, cameras,
                    etc. Such items in the possession of students will be
                    confiscated.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    The school is not responsible for any goods or money lost.
                    Students are advised not to bring valuable articles to
                    school. Jewellery of any kind is not allowed in the school.
                    All articles found in school and not claimed shall be
                    disposed of after a month.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Visitors are not allowed to interview teachers in their
                    respective classrooms during teaching hours.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Parents are requested not to bring or send food or other
                    articles to their children during class hours or breaks.
                    They may not be permitted to enter the campus for such
                    purposes. Students will not be permitted to meet their
                    parents or guardians at the gate during breaks.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    For safety reasons, parents are requested not to send
                    persons who have not been introduced to the school
                    beforehand to pick up their ward, even in times of
                    emergency. Parents must bring the escort card when they come
                    to pick up their ward. No student is permitted to leave the
                    school without an escort card. Students who are going home
                    alone should submit a permission letter signed by both
                    father and mother to the office every year.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Parents are requested not to attempt to go to their child's
                    classroom. They should contact the school office, and the
                    student concerned may be called out if the reason given is
                    judged to be serious enough.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Parents can meet the teachers every month as allotted by the
                    school. Meetings with teachers are not allowed just after
                    the previous week's examinations.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    The school reserves the right to dismiss students whose
                    diligence or progress in studies is steadily unsatisfactory,
                    whose conduct is harmful to other students, or whose
                    guardians show little interest in the progress of their
                    wards.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Private tuitions are discouraged, as they do not help
                    children to grow intellectually. In any case, no student
                    should avail private tuition from the teachers of Carmel
                    School.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    No vehicles are allowed inside the school compound. Cyclists
                    must not ride inside the compound.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Students who come to school for any purpose must be in
                    school uniform.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    Parents are requested to clear the fees of their ward
                    between the 1st and 15th of every month and bring the fee
                    book on result days.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Affiliation;
